<template>
  <div class="mall-h5">
    <div class="mh5-topbar">
      <van-icon name="arrow-left" @click="goBack" />
      <span>提交结果</span>
    </div>

    <div class="mh5-result">
      <!-- 状态图标 -->
      <div class="mh5-result__icon">
        <van-icon name="underway-o" />
      </div>

      <!-- 状态文案 -->
      <div class="mh5-result__text">订单提交成功</div>
      <div class="mh5-result__sub" v-if="orderNo">订单号：{{ orderNo }}</div>

      <!-- 待确认提示 -->
      <div class="mh5-result__hint">
        <van-icon name="warning-o" /> 线下付款待确认 · 请联系管理员确认到账
      </div>

      <!-- 订单详情卡片 -->
      <div class="mh5-result__order" v-if="order">
        <div class="mh5-result__order-head">订单详情</div>
        <div class="mh5-result__row">
          <span>实付金额</span>
          <span class="mh5-price">¥{{ order.totalAmount }}</span>
        </div>
        <div class="mh5-result__row" v-if="order.receiverName || order.receiverPhone">
          <span>收货人</span>
          <span>{{ order.receiverName }} {{ order.receiverPhone }}</span>
        </div>
        <div class="mh5-result__row" v-if="formatAddress(order)">
          <span>收货地址</span>
          <span>{{ formatAddress(order) }}</span>
        </div>
        <div class="mh5-result__row">
          <span>订单状态</span>
          <span class="mh5-result__status">{{ statusName(order.orderStatus) }}</span>
        </div>
      </div>
      <div class="mh5-result__order mh5-result__order--loading" v-else>
        <van-loading type="spinner" size="20px">加载订单信息...</van-loading>
      </div>

      <!-- 线下付款说明 -->
      <div class="mh5-notice">
        <div class="mh5-notice__head">
          <van-icon name="info-o" />
          <span>线下付款说明</span>
        </div>
        <ol class="mh5-notice__list">
          <li>请联系管理员/客服确认付款金额与付款方式。</li>
          <li>管理员确认到账后，订单将转为「已支付」并安排发货。</li>
          <li>您可在「订单查询」中随时查看订单状态。</li>
        </ol>
      </div>

      <!-- 操作按钮 -->
      <div class="mh5-result__btns">
        <div class="mh5-btn-ghost" @click="goList">继续购物</div>
        <div class="mh5-btn-primary" @click="goOrderDetail">查看订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mallH5OrderDetail } from '@/api/mall'
import { restoreMallCtx, withCtx } from './mallCtx'

const STATUS_MAP = {
  0: '待支付',
  1: '已支付',
  2: '已发货',
  3: '已退单',
  4: '已取消',
  5: '待确认'
}

export default {
  name: 'MallH5OfflineResult',
  data() {
    return {
      orderNo: '',
      order: null
    }
  },
  created() {
    restoreMallCtx(this.$route)
    this.orderNo = this.$route.query.orderNo
    if (this.orderNo) this.fetchOrder()
  },
  methods: {
    statusName(s) { return STATUS_MAP[s] || '未知' },
    async fetchOrder() {
      try {
        const res = await mallH5OrderDetail(this.orderNo)
        this.order = res.data
      } catch (e) { /* ignore */ }
    },
    formatAddress(o) {
      return [o.receiverProvince, o.receiverCity, o.receiverDistrict, o.receiverAddress].filter(Boolean).join('')
    },
    goBack() { this.$router.back() },
    goList() { this.$router.replace({ path: '/h5/mall/list', query: withCtx() }) },
    goOrderDetail() {
      // 跳转到订单查询页(免登录,按收货手机号查询订单)
      window.location.href = window.location.origin + (process.env.BASE_URL || '/') + 'h5/mall/inquiry'
    }
  }
}
</script>

<style scoped>
/* ===== 全局基调 ===== */
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  -webkit-font-smoothing: antialiased;
}

/* ===== 顶部导航 ===== */
.mh5-topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  background: #fff;
  font-size: 17px;
  font-weight: 600;
  color: #3C3C3C;
  padding: 0 14px;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.mh5-topbar i {
  position: absolute;
  left: 14px;
  font-size: 20px;
  color: #666;
  cursor: pointer;
}

/* ===== 结果页主体 ===== */
.mh5-result {
  padding: 40px 20px 40px;
  text-align: center;
}

/* 状态图标 */
.mh5-result__icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  background: linear-gradient(135deg, #C9A96E, #B8944E);
  box-shadow: 0 8px 24px rgba(201,169,110,0.3);
}
.mh5-result__icon .van-icon {
  font-size: inherit;
  color: inherit;
}

/* 状态文案 */
.mh5-result__text {
  font-size: 20px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 8px;
}
.mh5-result__sub {
  font-size: 14px;
  color: #B0A89E;
  margin-bottom: 4px;
}
.mh5-result__hint {
  font-size: 13px;
  color: #C9A96E;
  margin-top: 8px;
}
.mh5-result__hint .van-icon {
  vertical-align: -1px;
  margin-right: 2px;
}

/* 订单详情卡片 */
.mh5-result__order {
  background: #fff;
  border-radius: 14px;
  margin: 24px 0 16px;
  padding: 16px;
  text-align: left;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.mh5-result__order--loading {
  text-align: center;
  padding: 28px 16px;
}
.mh5-result__order-head {
  font-size: 16px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F0ECE6;
}
.mh5-result__row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
}
.mh5-result__row + .mh5-result__row {
  border-top: 1px solid #F8F4F0;
}
.mh5-result__row span:first-child {
  color: #B0A89E;
  flex-shrink: 0;
}
.mh5-result__row span:last-child {
  color: #3C3C3C;
  text-align: right;
  max-width: 62%;
  word-break: break-all;
}
.mh5-price {
  color: #C0392B;
  font-weight: 600;
}
.mh5-result__status {
  color: #C9A96E !important;
  font-weight: 500;
}

/* 线下付款说明 */
.mh5-notice {
  background: #FFF9F0;
  border: 1px solid #F0E4CC;
  border-radius: 12px;
  padding: 14px 16px;
  text-align: left;
  margin-bottom: 24px;
}
.mh5-notice__head {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #B8944E;
  margin-bottom: 8px;
}
.mh5-notice__head .van-icon {
  font-size: 16px;
  margin-right: 4px;
}
.mh5-notice__list {
  margin: 0;
  padding-left: 18px;
  color: #8C7A5A;
  font-size: 13px;
  line-height: 1.7;
}
.mh5-notice__list li + li {
  margin-top: 2px;
}

/* 操作按钮 */
.mh5-result__btns {
  display: flex;
  gap: 12px;
  padding: 0 4px;
}
.mh5-btn-ghost {
  flex: 1;
  height: 44px;
  line-height: 44px;
  border: 1px solid #C0392B;
  color: #C0392B;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.mh5-btn-ghost:active {
  background: rgba(192,57,43,0.05);
}
.mh5-btn-primary {
  flex: 1;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(192,57,43,0.25);
  cursor: pointer;
  transition: opacity 0.2s;
}
.mh5-btn-primary:active {
  opacity: 0.9;
}
</style>
